import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MessagingCenter = () => {
  const [activeTab, setActiveTab] = useState('unread');

  const messages = [
    {
      id: 1,
      sender: 'Équipe Artis.io',
      subject: 'Nouvelles fonctionnalités disponibles',
      preview: 'Découvrez les nouveaux outils d\'analyse et de reporting qui vous aideront à optimiser vos performances...',
      timestamp: new Date('2024-09-06T18:45:00'),
      isRead: false,
      isImportant: true,
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face'
    },
    {
      id: 2,
      sender: 'Club Le Zenith',
      subject: 'Confirmation de réservation - DJ Martin',
      preview: 'Nous confirmons la réservation de DJ Martin Dubois pour le samedi 14 septembre. Tous les détails sont...',
      timestamp: new Date('2024-09-06T16:20:00'),
      isRead: false,
      isImportant: false,
      avatar: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=32&h=32&fit=crop&crop=face'
    },
    {
      id: 3,
      sender: 'Festival d\'Été Lyon',
      subject: 'Opportunité de partenariat',
      preview: 'Nous organisons un festival de musique électronique et recherchons des partenaires pour nous aider...',
      timestamp: new Date('2024-09-06T14:30:00'),
      isRead: false,
      isImportant: true,
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=32&h=32&fit=crop&crop=face'
    },
    {
      id: 4,
      sender: 'Support Artis.io',
      subject: 'Réponse à votre demande #12345',
      preview: 'Merci pour votre question concernant le calcul des commissions. Voici les informations demandées...',
      timestamp: new Date('2024-09-06T12:15:00'),
      isRead: true,
      isImportant: false,
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=32&h=32&fit=crop&crop=face'
    },
    {
      id: 5,
      sender: 'Bar Le Groove',
      subject: 'Demande de devis - Soirée DJ',
      preview: 'Nous souhaitons organiser une soirée DJ pour le 20 septembre et aimerions avoir un devis pour...',
      timestamp: new Date('2024-09-05T19:45:00'),
      isRead: true,
      isImportant: false,
      avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=32&h=32&fit=crop&crop=face'
    }
  ];

  const filteredMessages = activeTab === 'unread' 
    ? messages?.filter(msg => !msg?.isRead)
    : messages;

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (hours < 24) {
      return `${hours}h`;
    } else {
      return `${days}j`;
    }
  };

  const unreadCount = messages?.filter(msg => !msg?.isRead)?.length;

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-card-foreground">Centre de messages</h3>
          <Button
            variant="ghost"
            size="sm"
            iconName="Plus"
            iconSize={16}
            onClick={() => console.log('Compose new message')}
          />
        </div>
        
        <div className="flex space-x-1 bg-muted rounded-lg p-1">
          <Button
            variant={activeTab === 'unread' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => setActiveTab('unread')}
            className="flex-1"
          >
            Non lus ({unreadCount})
          </Button>
          <Button
            variant={activeTab === 'all' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => setActiveTab('all')}
            className="flex-1"
          >
            Tous ({messages?.length})
          </Button>
        </div>
      </div>
      <div className="max-h-80 overflow-y-auto">
        {filteredMessages?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Mail" size={48} className="text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">
              {activeTab === 'unread' ? 'Aucun message non lu' : 'Aucun message'}
            </p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {filteredMessages?.map((message) => (
              <div
                key={message?.id}
                className={`p-4 hover:bg-muted/50 transition-colors duration-150 cursor-pointer ${
                  !message?.isRead ? 'bg-accent/5' : ''
                }`}
                onClick={() => console.log('Open message', message?.id)}
              >
                <div className="flex items-start space-x-3">
                  <div className="relative">
                    <img
                      src={message?.avatar}
                      alt={message?.sender}
                      className="w-10 h-10 rounded-full object-cover"
                      onError={(e) => {
                        e.target.src = '/assets/images/no_image.png';
                      }}
                    />
                    {!message?.isRead && (
                      <div className="absolute -top-1 -right-1 w-3 h-3 bg-accent rounded-full border-2 border-card"></div>
                    )}
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <p className={`text-sm font-medium truncate ${
                          !message?.isRead ? 'text-card-foreground' : 'text-muted-foreground'
                        }`}>
                          {message?.sender}
                        </p>
                        {message?.isImportant && (
                          <Icon name="Star" size={12} className="text-warning fill-current" />
                        )}
                      </div>
                      <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
                        {formatTimestamp(message?.timestamp)}
                      </span>
                    </div>
                    
                    <p className={`text-sm truncate mt-1 ${
                      !message?.isRead ? 'text-card-foreground font-medium' : 'text-muted-foreground'
                    }`}>
                      {message?.subject}
                    </p>
                    
                    <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                      {message?.preview}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="p-4 border-t border-border">
        <div className="flex space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="MessageSquare"
            iconPosition="left"
            iconSize={14}
            onClick={() => console.log('Open full messaging')}
            className="flex-1"
          >
            Voir tous les messages
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="Send"
            iconPosition="left"
            iconSize={14}
            onClick={() => console.log('Compose message')}
            className="flex-1"
          >
            Nouveau message
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MessagingCenter;